import styled from '@emotion/styled'

export const StyledList = styled.ul`
  margin: 4px 0;
  padding: 0 20px;
`